import * as React from "react"
import { ColorPickerSeeker } from "@ui-seeker/core"

import { useAdminBrandForm } from "../../@hooks"


export default function AdminBrandsColorPicker({ disabled }) {
	const { value, handleChange } = useAdminBrandForm('color')

    return <ColorPickerSeeker
		label="Brand Colour"
		value={value}
		disabled={disabled}
		onChange={handleChange}
	/>
}